import { jsx } from "react/jsx-runtime";
import React__default from "react";
import classNames from "classnames";
import { FormSize, AnalyticsId } from "./constants.js";
import formGroupStyles from "./components/FormLayout/styles.module.scss";
var FormLayoutColumns = /* @__PURE__ */ ((FormLayoutColumns2) => {
  FormLayoutColumns2["one"] = "one";
  FormLayoutColumns2["two"] = "two";
  FormLayoutColumns2["three"] = "three";
  FormLayoutColumns2["four"] = "four";
  FormLayoutColumns2["five"] = "five";
  return FormLayoutColumns2;
})(FormLayoutColumns || {});
const FormLayout = React__default.forwardRef((props, ref) => {
  const { maxColumns: columns = "one", colMinWidth = 300, size, className, mapHelper } = props;
  const cssVariable = { "--min-col-width": `${colMinWidth}px` };
  const formLayoutContainerClasses = classNames(
    formGroupStyles["form-layout-container"],
    {
      [formGroupStyles["form-layout-container--large"]]: size === FormSize.large
    },
    className
  );
  const formLayoutChildClasses = classNames(formGroupStyles["form-layout-child"], {
    [formGroupStyles["form-layout-child--two"]]: columns === "two",
    [formGroupStyles["form-layout-child--three"]]: columns === "three",
    [formGroupStyles["form-layout-child--four"]]: columns === "four",
    [formGroupStyles["form-layout-child--five"]]: columns === "five"
    /* five */
  });
  return /* @__PURE__ */ jsx(
    "div",
    {
      "data-testid": props.testId,
      "data-analyticsid": AnalyticsId.FormLayout,
      style: cssVariable,
      className: formLayoutContainerClasses,
      ref,
      children: React__default.Children.map(props.children, (child, index) => {
        return /* @__PURE__ */ jsx("div", { className: formLayoutChildClasses, children: mapHelper ? mapHelper(child, index) : child });
      })
    }
  );
});
FormLayout.displayName = "FormLayout";
export {
  FormLayout as F,
  FormLayoutColumns as a
};
//# sourceMappingURL=FormLayout.js.map
